import Vue from 'vue'
import VueRouter from 'vue-router'
import Hello from '../views/Hello.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Hello',
        component: Hello
    },
    {
        path: '/mi-perfil',
        alias: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    },
    {
        path: '/consultas',
        alias: '/appoinments',
        name: 'Appoinments',
        component: () => import(/* webpackChunkName: "about" */ '../views/Appoinments.vue')
    },
    {
        path: '/carta-astral',
        alias: '/astralcard',
        name: 'AstralCard',
        component: () => import(/* webpackChunkName: "about" */ '../views/AstralCard.vue')
    },
    {
        path: '/contacto',
        alias: '/contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
    },
    {
        path: '/nueva-consulta',
        alias: '/newconsult',
        name: 'NewConsult',
        component: () => import(/* webpackChunkName: "about" */ '../views/NewConsult')
    },
    {
        path: '/pago-consulta',
        alias: '/payconsult',
        name: 'PayConsultation',
        component: () => import(/* webpackChunkName: "about" */ '../views/PayConsultation')
    }
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})
// router.beforeEach((to, from, next) => {
//     if (to.fullPath.indexOf("sso=")){
//         let token = to.fullPath.split('sso=')[1]
//         localStorage.setItem("token", token)
//         localStorage.setItem("sendAstralCard", "true")
//     }
//     next()
// })


export default router
